<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'ItineraryDayProgramCopyModal',
  props: {
    itineraryId: {
      type: Number,
      required: true,
    },
    dayProgramEntry: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      toggled: true,
      error: false,
      loadingFact: null,
      errorMessage: null,
    };
  },
  methods: {
    ...mapActions({
      copyDayProgramEntry: 'itinerary/copyDayProgramEntry',
    }),
    getDayProgramDayNumber(dayProgram) {
      return this.dayProgramItems.findIndex(dayProgramItem =>
        dayProgramItem.id === dayProgram.id) + 1;
    },
    copyDayProgram() {
      this.copyDayProgramEntry(
        {
          dayProgramEntry: this.dayProgramEntry,
          itineraryId: this.itineraryId,
        }).then(() => {
        this.error = false;
        this.$emit('close');
      }).catch(() => {
        this.error = true;
      });
    },
    setLoadingFact() {
      this.loadingFact = this.randomLoadingFacts[Math.floor(Math.random() * this.randomLoadingFacts.length)];
      setTimeout(() => {
        if (this.loading) {
          this.setLoadingFact();
        }
      }, 5000);
    },
  },
  computed: {
    ...mapState({
      dayProgramItems: state => state.itinerary.dayProgram.items,
      loadingCurrentStep: state => state.app.loading.steps.current,
      loadingTotalSteps: state => state.app.loading.steps.total,
      randomLoadingFacts: state => state.app.loading.randomLoadingFacts,
      randomErrorMessages: state => state.app.loading.randomErrorMessages,
      loading: state => state.app.loading.state,
    }),
    affectedDayProgramItems() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dayProgramItems.filter(dayProgramItem =>
        dayProgramItem.areaId === this.dayProgramEntry.areaId
        && dayProgramItem.description === this.dayProgramEntry.description
        && dayProgramItem.id !== this.dayProgramEntry.id,
      );
    },
    loadingPercentage() {
      if (this.loadingTotalSteps && this.loadingTotalSteps > 0) {
        return Math.round((this.loadingCurrentStep / this.loadingTotalSteps) * 100);
      }
      return 0;
    },
  },
  watch: {
    toggled(value) {
      if (!value) {
        this.$emit('close');
      }
    },
    loading(value) {
      if (value) {
        this.setLoadingFact();
      }
    },
    error() {
      this.errorMessage = this.randomErrorMessages[Math.floor(Math.random() * this.randomErrorMessages.length)];
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    max-width="800px"
    :persistent="loading"
  >
    <v-card>
      <v-container v-if="!loading">
        <v-flex font-weight-bold pa-3 title>
          <b>{{ `Day ${getDayProgramDayNumber(dayProgramEntry)}: ` }}</b>{{ `${dayProgramEntry.description}` }}
        </v-flex>
        <template v-if="affectedDayProgramItems.length">
          <v-flex pa-3>
            Copying this day program entry will have an effect on the following entries:
          </v-flex>
          <v-flex
            v-for="(dayProgramItem, index) in affectedDayProgramItems"
            :key="`day-program-item-${index}`"
            pl-3
          >
            <b>{{ `Day ${getDayProgramDayNumber(dayProgramItem)}: ` }}</b>{{ `${dayProgramItem.description}` }}
          </v-flex>
          <v-flex pa-3>
            All content except images will be copied over to all entries mentioned above.
          </v-flex>
        </template>
        <template v-else>
          <flex pa-3>
            Not able to copy entry since no other day program entries will be affected.
          </flex>
        </template>
      </v-container>
      <v-container v-else-if="error">
        <v-flex pa-3>
          {{ errorMessage }}
        </v-flex>
      </v-container>
      <v-container v-else justify-center>
        <v-flex justify-center>
          <v-progress-linear :value="loadingPercentage" />
        </v-flex>
        <v-flex pa-2 style="text-align: center;">
          <b>{{ loadingCurrentStep }}</b> day program entry out of <b>{{ loadingTotalSteps }}</b> copied
        </v-flex>
        <v-flex pa-2 style="text-align: center;">
          <b>Did you know:</b> {{ loadingFact }}
        </v-flex>
        <v-flex pa-2 style="text-align: center;">
          <b>Please do not exit or reload the page when it is loading</b>
        </v-flex>
      </v-container>
      <v-divider light/>
      <v-layout justify-end>
        <v-btn
          :disabled="loading"
          color="red darken-1"
          flat
          @click="$emit('close')"
        >
          Cancel
        </v-btn>
        <v-btn
          :disabled="loading || error || !affectedDayProgramItems.length"
          color="blue darken-1"
          flat
          @click="copyDayProgram"
        >
          Copy
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryDayProgramCopyModal.vue